import {
  DEPARTMENT_MAX_CODE_LENGTH,
  DEPARTMENT_MAX_NAME_LENGTH,
  IDepartment,
  IDepartmentData,
  IDepartmentFieldError,
  IDepartmentFieldErrorData
} from './department.types';

export class Department implements IDepartment {
  readonly id?: number;
  readonly code: string = '';
  readonly name: string = '';
  readonly production: boolean = false;

  constructor(data?: IDepartmentData) {
    if (data) {
      if (data.id) {
        this.id = data.id;
      }

      this.production = data.production ?? false;

      this.code = data.code;
      this.name = data.name;
    }
  }

  validate(): boolean {
    // ensure department code is valid
    if (!this.code || this.code.length > DEPARTMENT_MAX_CODE_LENGTH) {
      return false;
    }

    // ensure department name is valid
    if (!this.name || this.name.length > DEPARTMENT_MAX_NAME_LENGTH) {
      return false;
    }

    return true;
  }

  get departmentInfo(): string {
    return `${this.code} - ${this.name}`.trim();
  }
}

export class DepartmentFieldError implements IDepartmentFieldError {
  code: string[] = [];
  name: string[] = [];
  production: string[] = [];

  constructor(data?: IDepartmentFieldErrorData) {
    if (data) {
      if (data.code) {
        this.code = data.code;
      }
      if (data.name) {
        this.name = data.name;
      }
      if (data.production) {
        this.production = data.production;
      }
    }
  }

  clearErrors(): void {
    this.name.splice(0, this.name.length);
    this.code.splice(0, this.code.length);
    this.production.splice(0, this.production.length);
  }

  static isDepartmentFieldError(data: IDepartmentFieldErrorData): boolean {
    if (data.code && Array.isArray(data.code)) {
      return true;
    } else if (data.name && Array.isArray(data.name)) {
      return true;
    } else if (data.production && Array.isArray(data.production)) {
      return true;
    }
    return false;
  }
}
